import React from 'react';
import { Box, Typography, Popover } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { AppButton } from '../../../components/UI';
import { ModeSelector, NumberChoice, SectionTitle, popoverPaperSx } from './SearchSettings';

const LancerRecherchePopover = ({
    anchorEl,
    onClose,
    filter,
    setFilter,
    limit,
    setLimit,
    onLancer,
    loading,
    limitOptions = [20, 30, 40, 50, 60],
    itemLabel = 'candidats',
}) => {
    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            slotProps={{ paper: { sx: popoverPaperSx } }}
        >
            <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#0f172a', mb: 2 }}>
                Paramètres de recherche
            </Typography>

            <ModeSelector filter={filter} setFilter={setFilter} />

            <Box sx={{ mb: 3 }}>
                <SectionTitle hint={`Nombre de ${itemLabel} affichés, du meilleur score au moins bon.`}>Résultats maximum</SectionTitle>
                <NumberChoice value={limit} setValue={setLimit} options={limitOptions} />
            </Box>

            <AppButton variant="primary" fullWidth onClick={onLancer} disabled={loading} startIcon={<AutoAwesome fontSize="small" />}>
                Lancer la recherche
            </AppButton>
        </Popover>
    );
};

export default LancerRecherchePopover;
